<div class="b-tag">
  <div [ngClass]="{
    'b-tag__tag': !isEditable,
    'b-tag__tag_editable': isEditable
  }">
    <span *ngIf="isEditable" [ngClass]="{
      'fa': true,
      'fa-check b-tag__loaded': !isLoading,
      'fa-clock b-tag__loading': isLoading
    }"></span>
    <span [style.color]="iconColor" [ngClass]="iconType" class="fa b-tag__format"></span>
    <span class="b-tag__doc-name">{{name}}</span>
    <span *ngIf="isEditable" (click)="remove()" class="b-tag__close-btn" >&times;</span>
  </div>
</div>
